import { useDecision } from '@optimizely/react-sdk'
import ErrorBoundary from '@space-shell/common/components/errorBoundary'

import { CommunityConfigurationSidebarProvider } from '@space-shell/modules/communities/communityConfigurationSidebar/context/communityConfigurationSidebar/communityConfigurationSidebarContext'
import { CommunityModalProvider } from '@space-shell/modules/communities/communityModal'

import { MembersImportProvider } from '@space-shell/modules/communities/context/membersImportProvider/provider'
import { MenuCollapseProvider } from '@space-shell/modules/communities/context/menuCollapseContext/menuCollapseContext'

import { DeleteCommunityModalProvider } from '@space-shell/modules/communities/deleteCommunityModal/context/deleteCommunityModalContext/deleteCommunityModalContext'
import { GroupCommunityModalProvider } from '@space-shell/modules/communities/groupCommunityModal/context/useGroupCommunityModal'

import { GroupDeleteCommunityModalProvider } from '@space-shell/modules/communities/groupDeleteCommunityModal/context/useGroupDeleteCommunityModal'
import { UnbanMemberCommunityModalProvider } from '@space-shell/modules/communities/unbanMemberCommunityModal/context/useUnbanMemberCommunityModal'

import SessionEventsWrapper from '../sessionEventsWrapper'

const Providers = ({ children }) => {
  const [{ enabled: enableNewCommunityMenu }] = useDecision('com_eng_web_enable_new_main_menu')

  const nonMigratedProviders = [
    SessionEventsWrapper,
    DeleteCommunityModalProvider,
    UnbanMemberCommunityModalProvider
  ]

  const defaultProviders = [
    ...nonMigratedProviders,
    MenuCollapseProvider,
    MembersImportProvider,
    CommunityConfigurationSidebarProvider,
    GroupDeleteCommunityModalProvider,
    CommunityModalProvider,
    GroupCommunityModalProvider
  ]

  const providersList = enableNewCommunityMenu ? nonMigratedProviders : defaultProviders

  return providersList.reduceRight(
    (PrevProvider, CurrentProvider) => (
      <ErrorBoundary>
        <CurrentProvider>{PrevProvider}</CurrentProvider>
      </ErrorBoundary>
    ),
    children
  )
}

export default Providers
